import action from "../helpers/rest-client";
import {
	BackupCodeDto,
	QRCodeResponseDto,
	VerifyAuthWithTokenDto,
	VerifyBackupCodeDto,
	VerifyQRCodeDto,
} from "../types/mfa.dto";

export class ErrorMFA extends Error {}

class MFA {
  /**
   * Get QR code for MFA setup
   */
  public async getQRCode(params: {
    userName: string;
    password: string;
  }): Promise<QRCodeResponseDto> {
    const encodedUserName = encodeURIComponent(params.userName);
    const encodedPassword = encodeURIComponent(params.password);

    return action
      .Get({
        url: `/authenticator2fa/getCodes?email=${encodedUserName}&service=Adecco-Legales&userName=${encodedUserName}&password=${encodedPassword}`,
      })
      .then((resp) => {
        return resp.success?.result || resp;
      })
      .catch((error) => {
        throw new ErrorMFA(error.message);
      });
  }

  /**
   * Verify QR code and enable MFA
   */
  public async verifyQRCode(payload: VerifyQRCodeDto): Promise<{
    success: boolean;
    message?: string;
    browser_hash?: string;
    code?: number;
    msg?: string;
  }> {
    return action
      .Post({
        url: "/authenticator2fa/verifyAuthenticator",
        body: payload,
      })
      .then((resp) => {
        return resp.success?.result || resp;
      })
      .catch((error) => {
        throw new ErrorMFA(error.message);
      });
  }

  /**
   * Verify MFA code with existing token (for regenerating backup code)
   */
  public async verifyAuthWithToken(
    payload: VerifyAuthWithTokenDto
  ): Promise<{
    success: boolean;
    message?: string;
  }> {
    return action
      .Post({
        url: "/authenticator2fa/verifyAuthWithToken",
        body: payload,
      })
      .then((resp) => {
        return resp.success?.result || resp;
      })
      .catch((error) => {
        throw new ErrorMFA(error.message);
      });
  }

  /**
   * Get backup code (requires authentication)
   */
  public async getBackupCode(): Promise<BackupCodeDto> {
    return action
      .Get({
        url: "/authenticator2fa/backupCode",
      })
      .then((resp) => {
        return resp.success?.result || resp;
      })
      .catch((error) => {
        throw new ErrorMFA(error.message);
      });
  }

  /**
   * Verify backup code (for account recovery)
   */
  public async verifyBackupCode(
    payload: VerifyBackupCodeDto
  ): Promise<boolean> {
    return action
      .Post({
        url: "/authenticator2fa/verifyBackupCode",
        body: payload,
      })
      .then((resp) => {
        return resp.success?.result || resp;
      })
      .catch((error) => {
        throw new ErrorMFA(error.message);
      });
  }
}

const mfa = new MFA();
export default mfa;
